import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PriceProp from "../props/priceProp.js";
import PropertyAddressProp from "../props/addressProp.js";
import { patchData } from "../fetchRoutes/patchData.js";
import { deleteData } from "../fetchRoutes/deleteData.js";
import { getData } from "../fetchRoutes/getData.js";

export default function PropertyCard({
  property,
  onButtonClick,
  buttonLabel,
  isAuctionDisabled,
  secondLabel,
  favorite,
  secondButtonLabel,
  myBids,
  winning,
  losing,
  onSecondButtonClick,
  thirdLabel,
  closeClass,
  onAuctionClose,
  onDeleteProperty,
  payment,
  onPaymentRequested,
  won
}) 

{
  const closeAuction = process.env.REACT_APP_GET_AN_AUCTION;

  const deleteProperty = process.env.REACT_APP_DELETE_PROPERTY;

  const requestPayment = process.env.REACT_APP_PAY_SESSION;

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [localPaymentStatus, setLocalPaymentStatus] = useState(property?.auction?.payment?.status);


  const navigate = useNavigate();

  const truncateTitle = (title) => {
    if (!title) return "";
    const words = title.split(" ");
    return words.length >= 5 ? words.slice(0, 2).join(" ") + "..." : title;
  };

  const handleViewDetails = (id) => {
    navigate(`/properties/property/${id}`);
  };

  // Close the auction
  const handleClose = async (id) => {

    if (!id) return;
    setIsLoading(true);

    const url = `${closeAuction}/${id}/close`;

    try {
      const response = await patchData(url);
      if (response.status === "Success") {
        setIsLoading(false);
        if (onAuctionClose) {
          onAuctionClose(id);
        }
      }
    } catch (error) {
      setErrorMessage(error.errorMessage || "Something went wrong");
      setTimeout(() => setErrorMessage(""), 3000);
    } finally {
      setIsLoading(false);
    }
  };

  // Contact the seller
  const handleContactSeller = () => {
    if (secondButtonLabel === "Contact seller" && onSecondButtonClick) {
      onSecondButtonClick(property.seller);
    } else if (onButtonClick) {
      onButtonClick(property);
    }
  };

  // Delete the property
  const handleDeleteProperty = async (id) => {

    if(!id){
      return;
    }
    setIsLoading(true);

    try{
      const url = `${deleteProperty}/${id}`;

      const response = await deleteData(url);

      if(response.status === 'Success'){
        setIsLoading(false);
        if (onDeleteProperty) {
          onDeleteProperty(id);
        }

      }
    }catch(error){
      setErrorMessage('Something went wrong');
      setTimeout(() => setErrorMessage(""), 3000);


    }finally{
      setIsLoading(false);
      setErrorMessage('');
    }

  }

  // Request Payment
  const handleRequestPayment = async(id) =>{
    if(!id){
      return;
    }

    setIsLoading(true);

    try{
      const url = `${requestPayment}/${id}/pay`;

      const response = await getData(url);

      if(response.status === 'Success'){
        setLocalPaymentStatus('pending');
        if (onPaymentRequested) {
          onPaymentRequested(); // tell parent to reload data
        }        

      }
    }catch(error){
      setErrorMessage('Something went wrong');
      setTimeout(() => setErrorMessage(""), 3000);
    }finally{
      setIsLoading(false);
      setErrorMessage('');
    }
  }


  return (
    <div
      key={property._id}
      className={`propertyCard ${winning ? "winningBid" : ""} ${losing ? "losingBid" : ""}`}
    >
      {isLoading && (
        <div className="loaderContainer">
          <div className="loader"></div>
          <p className="loadingText">Requesting Payment...</p>
        </div>
      )}

      <div
        className="cardImage"
        style={{
          backgroundImage: `url(${process.env.REACT_APP_BACKEND}/${property.images[0].replace("public/", "")})`
        }}
      ></div>

      <div className="propertyInfo">
        <h2 className="myPropertyTitle">{truncateTitle(property.title)}</h2>


        {payment ? (
          <PriceProp
            mainClassName="price"
            spanClassname1={`propertyPrice ${winning && 'winningAmount'} ${losing && 'losingAmount'}`}
            spanClassname2="favorite"
            property={property?.auction.highestBid?.bidAmount || property}
            myProperty={true}
            favorite={favorite}
            payment
          />
          ):(

          <PriceProp
            mainClassName="price"
            spanClassname1={`propertyPrice ${winning && 'winningAmount'} ${losing && 'losingAmount'}`}
            spanClassname2="favorite"
            property={property}
            myProperty={true}
            favorite={favorite}
          />

        )}
       
        <PropertyAddressProp
          mainClassName="roomAddress"
          roomClassName="houseRoomsDetails"
          addressClassName="propertyAddress"
          property={property}
          isProperty={false}
        />

        {errorMessage && <p className="errorMessage">{errorMessage}</p>}

        <div className="propertyButtons">
          {!myBids && !payment && !won && (
            <button
              className={`btnAuction ${isAuctionDisabled ? "auctionDisabled" : secondButtonLabel ? "secondButton" : ''} ${ closeClass ? 'closeAuction':''}`}
              onClick={()=>{
                if (closeClass && property.auction?.status !== "closed") {
                  handleClose(property.auction._id);
                }else{
                  handleContactSeller()}
              }}

              disabled={isAuctionDisabled}
            >
              {buttonLabel ? buttonLabel : secondButtonLabel}
            </button>

          )}

          {payment && (
            <button
              className={`btnAuction 
                ${isAuctionDisabled ? "auctionDisabled" : ""} 
                ${property?.auction?.status === 'cancelled' ? "auctionCancelled" : ''} 
                ${localPaymentStatus === 'successful' ? "auctionSuccessful auctionDisabled" : ''} 
                ${secondButtonLabel ? "secondButton" : ''} 
                ${closeClass ? 'closeAuction' : ''}`}
              
              onClick={() => {
                if (!property?.auction?.payment && localPaymentStatus !== 'pending') {
                  handleRequestPayment(property.auction._id);
                } else if (closeClass && property.auction?.status !== "closed") {
                  handleClose(property.auction._id);
                } else {
                  handleContactSeller();
                }
              }}
            
              disabled={isAuctionDisabled || localPaymentStatus === 'pending' || localPaymentStatus === 'successful'}
            >
              {localPaymentStatus === 'pending'
                ? "Payment Requested":
                localPaymentStatus === 'successful'
                ? "Succesful":
                localPaymentStatus === 'cancelled'
                ? "Payment Cancelled"
                : buttonLabel || secondButtonLabel || 'Request Payment'}
            </button>
          )}


          {!payment && 
             <button
              className={`btnDetails ${thirdLabel ? 'deleteProperty': ''}`}
              onClick={() => {
                if (secondLabel && property.auction?.status !== "closed") {
                  handleClose(property.auction._id);
                } else if(thirdLabel){
                  handleDeleteProperty(property._id)
                }
                else {
                  handleViewDetails(property._id);
                }
               
             }}
            >
              {secondLabel && property.auction && property.auction?.status !== "closed"
                ? "Close Auction"
                : thirdLabel ? thirdLabel : "View Details"}
            
            </button>
          
          }
           
        
        </div>
      </div>
    </div>
  );
}
